module.exports = __webpack_public_path__ + "img/sk-partners-ta3.0dd1b8c8.png";